import React, { useEffect } from "react";
import { GiCheckMark } from "react-icons/gi";
import { IoMdSync } from "react-icons/io";
import Accordion from "../../components/shared/Accordion/Accordion";
import { PurchaseHistoryModal } from "../credits/components/PurchaseHistoryButton/PurchaseHistoryModal";
import ModalHandlePurchase from "./ModalHandlePurchase/ModalHandlePurchase";
import StudentCreditsManageTable from "./StudentCreditsManageTable/StudentCreditsManageTable";

import {
  StudentCreditsProvider,
  useStudentCredits,
} from "./StudentCreditsContext";
import Spinner from "../../components/shared/spinner/Spinner";

function StudentCreditsManageInner() {
  const {
    user,
    isUserLoading,
    coachCreditOverview,
    isStudentsLoading,
    students,
    totalStudents,
    handleAutoRenewal,
    handleUpgradeStudent,
    tableOptions,
    setTableOptions,
    isOpen,
    setIsOpen,
    isPurchaseCreditsOpen,
    setIsPurchaseCreditsOpen,
    fetchUser,
  } = useStudentCredits();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    if (params.has("isPurchaseCredits")) {
      setIsPurchaseCreditsOpen(true);
    }
  }, [setIsPurchaseCreditsOpen]);

  return (
    <div style={{ width: "100%" }} className="font-manrope mx-auto py-4">
      <div className="px-4 flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <div className="text-3xl font-semibold">{user?.creditCount ?? 0}</div>
          <div className="text-base font-semibold">Credits Available</div>
        </div>

        {students?.length !== 0 && (
          <div className="flex items-center gap-1 px-4 py-3 bg-primary50 rounded-xl">
            <IoMdSync className="text-primary700 text-sm font-semibold" />
            <div className="text-primary700 text-sm font-semibold">
              {coachCreditOverview?.renewalCount ?? 0} Auto-renewals
            </div>
          </div>
        )}

        <Accordion
          arrowColor="text-gray700"
          titlePadding="px-4 py-3"
          contentPadding="px-4 pb-3"
          className="w-full rounded-xl bg-gray100 overflow-hidden"
          content={[
            <React.Fragment key="content">
              <div className="text-grayTrue800 text-sm">
                Credits are a great way for your students to continue practicing
                with unlimited swings and more
              </div>
              <div className="mt-3 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-x-2 gap-y-2 md:gap-y-6 md:gap-x-6">
                {[
                  "Unlimited swings",
                  "Handsfree Mode",
                  "Drawing Tools",
                  "Library of 50+ practice drills",
                  "Buy in bulk and save up to 15% OFF",
                  "2D & 3D comparison modes",
                ].map((item) => (
                  <span key={item} className="flex items-start gap-3">
                    <div className="flex items-center justify-center bg-primary100 w-6 min-w-6 h-6 min-h-6 rounded-full">
                      <GiCheckMark className="p-0.5 text-primary700" />
                    </div>
                    <div className="text-sm text-grayTrue700">{item}</div>
                  </span>
                ))}
              </div>
            </React.Fragment>,
          ]}
          showLine={false}
          title={[
            <div className="text-sm font-bold text-black" key="what">
              What is this?
            </div>,
          ]}
        />
      </div>

      <div className="px-4 flex flex-col gap-2 mt-6">
        <button
          onClick={() => setIsPurchaseCreditsOpen(true)}
          className="btnPrimary500 min-h-11 h-11 rounded-full"
        >
          Add credits
        </button>
        <button
          onClick={() => setIsOpen(true)}
          className="btnGray100 min-h-11 h-11 rounded-full"
        >
          Purchase history
        </button>

        <PurchaseHistoryModal isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>

      <div className="min-h-12 ml-4 pr-4 mt-6">
        {isStudentsLoading || isUserLoading ? (
          <div className="flex items-center justify-center">
            <Spinner color="primary500" size="md" />
          </div>
        ) : (
          <StudentCreditsManageTable
            students={students}
            handleAutoRenewal={handleAutoRenewal}
            handleUpgradeStudent={handleUpgradeStudent}
            user={user}
            currentPage={tableOptions.page}
            pageNumber={Math.ceil(totalStudents / tableOptions.limit)}
            onPageChange={(page) =>
              setTableOptions((prev) => ({ ...prev, page }))
            }
            onAddCredits={() => setIsPurchaseCreditsOpen(true)}
          />
        )}
      </div>

      <ModalHandlePurchase
        isOpen={isPurchaseCreditsOpen}
        onClose={() => setIsPurchaseCreditsOpen(false)}
        handleRefetchCredits={fetchUser}
      />
    </div>
  );
}

export default function StudentCreditsManage() {
  return (
    <StudentCreditsProvider>
      <StudentCreditsManageInner />
    </StudentCreditsProvider>
  );
}
